import { render, staticRenderFns } from "./project-detail.vue?vue&type=template&id=1d59fbde"
import script from "./project-detail.vue?vue&type=script&lang=js"
export * from "./project-detail.vue?vue&type=script&lang=js"
import style0 from "./project-detail.vue?vue&type=style&index=0&id=1d59fbde&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports